/**
 * Returns the current width of the scrollbar.
 */
export default function getScrollbarWidth() {
  var scrollable = document.createElement('div');
  scrollable.style.width = '99px';
  scrollable.style.height = '99px';
  scrollable.style.position = 'absolute';
  scrollable.style.top = '-9999px';
  scrollable.style.overflow = 'scroll';
  document.body.appendChild(scrollable);
  var scrollbarWidth = scrollable.offsetWidth - scrollable.clientWidth;
  document.body.removeChild(scrollable);
  return scrollbarWidth;
}
//# sourceMappingURL=getScrollbarWidth.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/getScrollbarWidth.js
// module id = 475
// module chunks = 0 1